module.exports = {"id":"220522","name":"Daniel Hernández","rating":"72","photo":"./data/images/photos/0/220522.png","club":{"name":"Águilas Doradas","logo":"./data/images/clubs/AguilasDoradas.png"},"positions":["MOC","MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DanielHernandez0.json
// module id = 934
// module chunks = 0